import React, { useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import QuestionFileUpload from '../../QuestionFileUpload';

const DateQuestion = ({ q, sectionIndex, error, handleChange, formData, setFormData, isDisabled, handleFiles }) => {
  const [answers, setAnswers] = useState((q.answers || []))
    
    return (
        <Box>
            <TextField
                type="date"
                fullWidth
                value={answers?.[0] || ''}
                onChange={(e) => {
                    if (handleChange) {
                        handleChange(sectionIndex, q, [e.target.value])
                        setAnswers([e.target.value])
                    }
                }}
            />
            <QuestionFileUpload
                q={q}
                sectionIndex={sectionIndex}
                isDisabled={isDisabled}
                handleFiles={handleFiles}
            />
            {error && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                    {error}
                </Typography>
            )}
        </Box>
    );
};

export default DateQuestion;
